import { DefaultPassThrough } from '@primevue/core'
import type { DataTableDesignTokens } from '@primeuix/themes/types/datatable'
import { DataTablePassThroughMethodOptions, DataTablePassThroughOptions } from 'primevue/datatable'
import Table from './Table.vue'
import { ColumnPassThroughOptions } from 'primevue/column'

export const ColumnPassThroughConfig: DefaultPassThrough<ColumnPassThroughOptions> = {
  columnHeaderContent: {
    class: 'tw-font-bold',
    style: 'font-weight: 700;' // TODO: Remove when Tailwind is fully supported
  },
  headerCell: {
    class: 'tw-border-y-1 tw-border-solid tw-border-border',
    style: 'border-width: 1px 0px ; border-style: solid; border-color: var(--border-default-color);' // TODO: Remove when Tailwind is fully supported
  }
}

export const TablePassthroughConfig: DefaultPassThrough<DataTablePassThroughOptions> = {
  root: {
    class: 'tw-flex tw-h-full tw-gap-2',
    style: 'display: flex; flex-direction: column; height: 100%; gap: 0.5rem;' // TODO: Remove when Tailwind is fully supported
  },
  tableContainer: {
    class: 'tw-flex tw-flex-col'
  },
  emptyMessage: {
    class: 'tw-text-center tw-py-32 tw-text-gray-500 tw-min-h-[150px]'
  },
  mask: {
    class: '!tw-bg-gray-100/70'
  },
  loadingIcon: {
    class: 'tw-text-body'
  },
  table: ({ props }: DataTablePassThroughMethodOptions) => {
    const classList = ['tw-border-x-1 tw-border-solid tw-border-border']
    const styleList = [
      'border-style: solid; border-color: var(--border-default-color); border-width: 0px 1px 0px 1px;'
    ] // TODO: Remove when Tailwind is fully supported
    if (props?.value?.length === 0) {
      classList.push('tw-min-h-full')
      styleList.push('min-height: 100%;')
    }
    return {
      class: classList,
      style: styleList.join(' ')
    }
  },
  headerRow: {
    class: 'tw-text-base/5'
  },
  thead: {
    class: 'tw-font-bold'
  },
  header: {
    class: 'tw-font-bold'
  },
  bodyRow: {
    class: 'tw-cursor-pointer',
    style: 'cursor: pointer;' // TODO: Remove when Tailwind is fully supported
  }
}

export const TableStyleConfig: DataTableDesignTokens = {
  root: {
    borderColor: 'var(--border-default-color)'
  },
  headerCell: {
    background: 'var(--color-surface-header)',
    hoverBackground: 'var(--border-default-color)',
    selectedBackground: 'var(--border-default-color)',
    gap: '3px',
    padding: 'var(--padding-sm) var(--padding-md)'
  },
  paginatorBottom: {
    borderWidth: '0'
  },
  paginatorTop: {
    borderWidth: '0'
  },
  row: {
    background: 'var(--color-surface-default)',
    hoverBackground: 'var(--color-surface-hover)',
    hoverColor: 'var(--color-text)',
    selectedBackground: 'var(--color-surface-pressed)',
    selectedColor: 'var(--color-text)'
  },
  columnTitle: {
    fontWeight: '700'
  },
  bodyCell: {
    borderColor: 'var(--border-default-color)',
    padding: 'var(--padding-sm) var(--padding-md)'
  },
  footer: {
    borderColor: 'var(--border-default-color)',
    borderWidth: '0 1px 1px 1px',
    padding: '10px 8px'
  },
  sortIcon: {
    size: '14px'
  },
  header: {
    color: 'var(--color-text)',
    borderColor: 'var(--border-default-color)',
    borderWidth: '1px 1px 0 1px',
    padding: 'var(--padding-sm) var(--padding-md)'
  }
}

export default Table
